module.exports = __webpack_public_path__ + "media/images/certificate_logo-b0fe07483ff94d8f10c97a9e5f325565.png";